import {
  UPDATE_EMPLOYEE_IMAGE,
  RESET_EMPLOYEE_IMAGE,
  FETCH_EMPLOYEE_IMAGE,
  FETCH_EMPLOYEE_IMAGE_START,
  FETCH_EMPLOYEE_IMAGE_SUCCESS,
  FETCH_EMPLOYEE_IMAGE_ERROR,
} from './constants'

import {
  buildAsyncAction,
} from 'containers/Async/actions'

const resetEmployeeImage = () => ({ type: RESET_EMPLOYEE_IMAGE })
const updateEmployeeImage = (img) => ({ type: UPDATE_EMPLOYEE_IMAGE, img })
const fetchEmployeeImage = (username) => ({ type: FETCH_EMPLOYEE_IMAGE, username })
const fetchEmployeeImageStart = () => ({ type: FETCH_EMPLOYEE_IMAGE_START })
const fetchEmployeeImageSuccess = (image) => ({ type: FETCH_EMPLOYEE_IMAGE_SUCCESS, image })
const fetchEmployeeImageError = (error) => ({ type: FETCH_EMPLOYEE_IMAGE_ERROR, error })
const startFetchEmployeeImageAsync = buildAsyncAction(
  FETCH_EMPLOYEE_IMAGE,
  FETCH_EMPLOYEE_IMAGE_START,
  [FETCH_EMPLOYEE_IMAGE_ERROR, FETCH_EMPLOYEE_IMAGE_SUCCESS]
)

export {
  startFetchEmployeeImageAsync,
  updateEmployeeImage,
  resetEmployeeImage,
  fetchEmployeeImage,
  fetchEmployeeImageStart,
  fetchEmployeeImageSuccess,
  fetchEmployeeImageError,
}
